import TableBody from "./TableBody";
import TableHeader from "./TableHeader";

const Table = ({ columns, sortColumn, isLoading, onSort, data }) => {
  return (
    <table className="min-w-full max-h-96 mb-5">
      <TableHeader columns={columns} sortColumn={sortColumn} onSort={onSort} />
      <TableBody columns={columns} data={data} isLoading={isLoading} />
    </table>
  );
};

export default Table;
